function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CompoundSurvey from "./compound-survey";
export default class CompoundSurveyFrequency {
  constructor(param) {
    _defineProperty(this, "surveyId", void 0);
    _defineProperty(this, "enabled", void 0);
    _defineProperty(this, "forgettingNumber", void 0);
    _defineProperty(this, "frequency", void 0);
    if (param instanceof CompoundSurvey) {
      this.surveyId = param.id;
      this.enabled = false;
      this.frequency = "never";
      this.forgettingNumber = 0;
    } else {
      const {
        surveyId,
        forgettingNumber,
        frequency,
        enabled
      } = param;
      this.surveyId = surveyId;
      this.forgettingNumber = forgettingNumber;
      this.frequency = frequency;
      this.enabled = enabled || false;
    }
  }

  /**
   * For testing purpose. Do not use as an UUID
   */
  get id() {
    return this.surveyId;
  }
  serialize() {
    return {
      surveyId: this.surveyId,
      forgettingNumber: this.forgettingNumber,
      frequency: this.frequency
    };
  }
}